module.exports = __webpack_public_path__ + "static/media/u44.af02a68a.png";